import React from "react";
import * as T from "./types";
import * as S from "./styles";
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import ComboBox from "@components/ComboBox";
import { DEFAULT_DEALER_ORGANIZATION, getDealerOrganizationsArray, ORGANIZATION_DAFAULT_VALUE } from "@utils/DOIgnition/utils";
import { cloneDeep } from "lodash";

const TemplateOrganization: React.FC<T.IProps> = (props) => {

  const authContext = React.useContext(AuthContext);

  const [statusOptions, setOrgOptions] = React.useState<string[]>([]);
  const [value, setValue] = React.useState("");

  const handleSelectOption = (id: string, selectedValue: string) => {
    const value = selectedValue === ORGANIZATION_DAFAULT_VALUE ? DEFAULT_DEALER_ORGANIZATION : selectedValue;
    setValue(value);
    const newFiles = cloneDeep(props.files);
    if (newFiles[props.currentIndex]) newFiles[props.currentIndex].organization = value;
    props.setFiles(newFiles);
  }

  React.useEffect(() => {
    setValue(props.files[props.currentIndex]?.organization ?? "");    
  }, [props.currentIndex, props.files.length]);

  React.useEffect(() => {
    if (authContext?.userData) {
      const newOrgOptions = getDealerOrganizationsArray(authContext.userData.profile['dealeron.dealerorganization']);
      setOrgOptions(newOrgOptions);
    }
  }, [authContext]);

  const isEnabledOrganization = () =>{

    if (props.files[props.currentIndex] && props.files[props.currentIndex].createdBy)
      return authContext.userData.profile.role==='DealerUser' &&  authContext.userData.profile.email == props.files[props.currentIndex].createdBy.email 

    return true;
  }

  return (
    <S.Root
      fromEditTemplate={props.fromEditTemplate}
    >
      <S.Title>
        Organization
      </S.Title>
      <ComboBox
        id="organization"
        placeholder="Select"
        options={[ORGANIZATION_DAFAULT_VALUE, ...statusOptions]}
        required={false}
        disabled={!isEnabledOrganization()}
        position={"bottom"}
        chooseOption={handleSelectOption}
        value={value === DEFAULT_DEALER_ORGANIZATION ? "" : value}
      />
    </S.Root>
  );
}

export default TemplateOrganization;